import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { react, useState } from 'react';
//import LoadingIndicator from '../components/LoadingIndicator';



//const AUTH_REST_API_URL = 'http://test.sipzee.com/Service/Order.svc';
                    

class TokenService {

   
    AUTH_REST_API_URL = 'http://localhost:65337/Service/Order.svc';
    constructor(props) {


       
        this.refreshAccessToken = this.refreshAccessToken.bind(this);
        this.getCookie = this.getCookie.bind(this);
        this.setCookie = this.setCookie.bind(this);
        // Request interceptor for API calls

        axios.interceptors.request.use(
            async config => {
                var token = this.getCookie('token');

                if (config.headers.Authorization == undefined) {
                    if (token !== '') {
                        config.headers = {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        }
                    }
                    else {
                        config.headers = {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
                }
                return config;
            },
            error => {
                Promise.reject(error)
            });

        // Response interceptor for API calls
        axios.interceptors.response.use((response) => {
            return response
        }, async function (error) {
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry && !originalRequest.url.endsWith('validateLogin') && !originalRequest.url.endsWith('refreshToken')) {
                originalRequest._retry = true;



                try {

                    let refreshToken = '';
                    let name = "refresh=";
                    let decodedCookie = decodeURIComponent(document.cookie);
                    let ca = decodedCookie.split(';');
                    for (let i = 0; i < ca.length; i++) {
                        let c = ca[i];
                        while (c.charAt(0) === ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) === 0) {
                            refreshToken = c.substring(name.length, c.length);
                            break;
                        }
                    }

                    const rsRefresh = await axios.post(this.AUTH_REST_API_URL + '/auth/refreshToken', {
                        refresh: refreshToken,
                    });

                    document.cookie = "token=" + rsRefresh.data.accessToken + ";path=/";
                    document.cookie = "refresh=" + rsRefresh.data.refreshToken + ";path=/";

                    return axios(originalRequest);
                }
                catch (_error) {
                    return Promise.reject(_error);
                }

                // const access_token = await (() => refreshAccessToken());            
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
                // return axios(originalRequest);
            }
            return Promise.reject(error);
        });
    }

    setWebToken(token) {
        this.setCookie('token', token,1000);
    }

    async post(postData, method, loadingMessage) {

        if (loadingMessage !== undefined) {
           // LoadingIndicator.showLoading(loadingMessage);
        }


        let postPromise = new Promise(function (resolve, reject) {
            let AUTH_REST_API_URL = '';
            if (window.location.href.indexOf('localhost') > -1) {
                AUTH_REST_API_URL = 'http://localhost:65337/Service/Order.svc';
               // AUTH_REST_API_URL = 'https://test.sipzee.com/Service/Order.svc';
            }
            else if (window.location.href.indexOf('test.sipzee.com') > -1) {
                AUTH_REST_API_URL = 'https://test.sipzee.com/Service/Order.svc';
            }
            else {
                AUTH_REST_API_URL = 'https://sipzee.com/Service/Order.svc';
            }

            axios({
                url: AUTH_REST_API_URL + '/' + method,
                method: 'post',
                data: postData
            })
                .then((response) => {
                //    LoadingIndicator.hideLoading();
                    resolve(response.data);
                }, (error) => {
                //    LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error', response: error.response });
                    }

                });



        });

        return postPromise;

    }

    async customerPost(postData, method, loadingMessage) {

        if (loadingMessage !== undefined) {
            // LoadingIndicator.showLoading(loadingMessage);
        }


        let postPromise = new Promise(function (resolve, reject) {
            let AUTH_REST_API_URL = '';
            if (window.location.href.indexOf('localhost') > -1) {
                AUTH_REST_API_URL = 'http://localhost:65337/Service/Customer.svc';
            }
            else if (window.location.href.indexOf('test.sipzee.com') > -1) {
                AUTH_REST_API_URL = 'https://test.sipzee.com/Service/Customer.svc';
            }
            else {
                AUTH_REST_API_URL = 'https://sipzee.com/Service/Customer.svc';
            }

            var token;
            try {

                token = JSON.parse(localStorage.getItem('Customer')).WebToken; // persists after window close
            }
            catch {
                console.log('Post: error getting the token');
            }

            var headerData = null;
            if (token !== undefined && token !== null && token !== '') {
                headerData = {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }
            else {
                console.log('TokenService: token was empty');
                headerData = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }

            axios({
                url: AUTH_REST_API_URL + '/' + method,
                method: 'post',
                headers: headerData,
                data: postData
            })
                .then((response) => {
                    //    LoadingIndicator.hideLoading();
                    try {
                        if (JSON.stringify(response.data).indexOf('Invalid Login by WebToken') > -1) {
                            localStorage.removeItem('Customer') // force a relogin
                            reject({ error: 'Unauthorized' });
                        }
                    }
                    catch {

                    }
                    resolve(response.data);
                }, (error) => {
                    //    LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error', response: error.response });
                    }

                });



        });

        return postPromise;

    }

    async postRecycler(postData, method, loadingMessage) {

        if (loadingMessage !== undefined) {
            // LoadingIndicator.showLoading(loadingMessage);
        }


        let postPromise = new Promise(function (resolve, reject) {
            let AUTH_REST_API_URL = '';
            if (window.location.href.indexOf('localhost') > -1) {
                AUTH_REST_API_URL = 'http://localhost:65337/Service/Returner.svc';
            }
            else if (window.location.href.indexOf('test.sipzee.com') > -1) {
                AUTH_REST_API_URL = 'https://test.sipzee.com/Service/Returner.svc';
            }
            else {
                AUTH_REST_API_URL = 'https://sipzee.com/Service/Returner.svc';
            }

            axios.post(AUTH_REST_API_URL + '/' + method, postData)
                .then((response) => {
                    //    LoadingIndicator.hideLoading();
                    resolve(response.data);
                }, (error) => {
                    //    LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error', response: error.response });
                    }

                });



        });

        return postPromise;

    }

    async postForm(postData, method, loadingMessage) {

        if (loadingMessage !== undefined) {
           // LoadingIndicator.showLoading(loadingMessage);
        }


        let postPromise = new Promise(function (resolve, reject) {

            axios.post(this.AUTH_REST_API_URL + '/' + method, postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            })
                .then((response) => {
               //     LoadingIndicator.hideLoading();
                    resolve(response.data);
                }, (error) => {
                    LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error' });
                    }

                });



        });

        return postPromise;

    }

    async get(method, loadingMessage) {
        if (loadingMessage !== undefined) {
        //    LoadingIndicator.showLoading(loadingMessage);
        }
        let postPromise = new Promise(function (resolve, reject) {

            axios.get(this.AUTH_REST_API_URL + '/' + method)
                .then((response) => {
                //    LoadingIndicator.hideLoading();
                    resolve(response.data);
                }, (error) => {
                //    LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error' });
                    }

                });

        });

        return postPromise;

    }

    async download(method, loadingMessage) {
        if (loadingMessage !== undefined) {
          //  LoadingIndicator.showLoading(loadingMessage);
        }
        let postPromise = new Promise(function (resolve, reject) {

            axios.get(this.AUTH_REST_API_URL + '/' + method,
                {
                    responseType: 'blob', // important
                })
                .then((response) => {
               //     LoadingIndicator.hideLoading();
                    resolve(response);
                }, (error) => {
               //     LoadingIndicator.hideLoading();
                    if (error.response !== null && error.response.status !== null && error.response.status === 401) {
                        reject({ error: 'Unauthorized' });
                    }
                    else {
                        console.log(error);
                        reject({ error: 'Post error' });
                    }

                });

        });

        return postPromise;

    }

    async refreshAccessToken(parm) {
        let postPromise = new Promise(function (resolve, reject) {
            try {
                let refreshToken = '';
                let name = "refresh=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) === 0) {
                        refreshToken = c.substring(name.length, c.length);
                        break;
                    }
                }

                const rsRefresh = axios.post(this.AUTH_REST_API_URL + '/auth/refreshToken', {
                    refresh: refreshToken,
                })
                    .then((response) => {
                        // repost
                        if (response != null) {
                            document.cookie = "token=" + response.data.accessToken + ";path=/";
                            document.cookie = "refresh=" + response.data.refreshToken + ";path=/";
                            resolve(parm);
                        }
                    },
                        (error) => {
                            return reject(parm);
                        });


            }
            catch (_error) {
                return reject(parm);
            }

        });

        return postPromise;
    }

    setCookie(cname, cvalue, exMins) {
        let expires = '';
        if (exMins !== null) {
            // no exMins means the cookie will delete when the browser is closed
            const d = new Date();
            d.setTime(d.getTime() + (exMins * 60 * 1000));
            expires = "expires=" + d.toUTCString() + ';';
        }

        document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
    }


    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    dataUploadUrl() {
        return this.AUTH_REST_API_URL + '/categorized/import/excel';
    }

}

export default new TokenService();  